import { PDF_BASE_URL } from "../../config";

export const AI_EXPLAINED_STATIC_BASE_URL = `${PDF_BASE_URL}/static/ai_explained`;

let photoRoundPromise = null;
let chatRoundPromise = null;
let productionRoundsPromise = null;

async function getJson(path) {
  const response = await fetch(`${AI_EXPLAINED_STATIC_BASE_URL}/${path}`, { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`AI Explained content request failed: HTTP ${response.status}`);
  }
  return response.json();
}

export function aiExplainedAssetUrl(relativePath) {
  const clean = String(relativePath || "").replace(/^\/+/, "");
  return `${AI_EXPLAINED_STATIC_BASE_URL}/${clean}`;
}

export function getRealOrAIPhotoRound({ force = false } = {}) {
  if (force || !photoRoundPromise) {
    photoRoundPromise = getJson("content/real_or_ai_photo_v1.json").catch((error) => {
      photoRoundPromise = null;
      throw error;
    });
  }
  return photoRoundPromise;
}

export function getRealOrAIChatRound({ force = false } = {}) {
  if (force || !chatRoundPromise) {
    chatRoundPromise = getJson("content/real_or_ai_chat_v1.json").catch((error) => {
      chatRoundPromise = null;
      throw error;
    });
  }
  return chatRoundPromise;
}

export function getRealOrAIProductionRounds({ force = false } = {}) {
  if (force || !productionRoundsPromise) {
    productionRoundsPromise = getJson("content/real_or_ai_index_v1.json")
      .then(async (index) => {
        const rows = Array.isArray(index?.productionRounds) ? index.productionRounds : [];
        return Promise.all(rows.map((row) => getJson(row.definition)));
      })
      .catch((error) => {
        productionRoundsPromise = null;
        throw error;
      });
  }
  return productionRoundsPromise;
}
